"use client";

import { useTranslations } from "next-intl";
import { ImageGalleryWithLightbox } from "@/components/ui/image-gallery-with-lightbox";
import { getLocationInstallationsGallery } from "@/data/location-installations";

type LocationInstallationsGalleryProps = {
  /** Province / city name used in the heading and in every photo's alt/title. */
  city: string;
};

export function LocationInstallationsGallery({ city }: LocationInstallationsGalleryProps) {
  const t = useTranslations("locationInstallationsGallery");
  const images = getLocationInstallationsGallery(city);

  return (
    <section className="px-4 pb-12">
      <div className="surface-card mx-auto max-w-6xl p-6 sm:p-8">
        <h2 className="text-brand-navy dark:text-white type-h2">
          {t("title", { city })}
        </h2>
        <p className="mt-3 text-sm sm:text-base text-gray-600 dark:text-gray-300">
          {t("subtitle", { city })}
        </p>
        <div className="mt-6">
          <ImageGalleryWithLightbox images={images} title={t("carouselTitle", { city })} />
        </div>
      </div>
    </section>
  );
}
